import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { CTAButton } from './components/CTAButton';
import { PriceDisplay } from './components/PriceDisplay';
import { PricingProvider } from './lib/pricing';
// Lazy load below-the-fold sections to reduce initial bundle size
const SalesLetter = lazy(() => import('./components/SalesLetter').then(m => ({
  default: m.SalesLetter
})));
const FeatureGrid = lazy(() => import('./components/FeatureGrid').then(m => ({
  default: m.FeatureGrid
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQAccordion = lazy(() => import('./components/FAQAccordion').then(m => ({
  default: m.FAQAccordion
})));
const WhatsAppCarousel = lazy(() => import('./components/WhatsAppCarousel').then(m => ({
  default: m.WhatsAppCarousel
})));
export function App() {
  useEffect(() => {
    // Preload hero image for fastest LCP
    const heroLink = document.createElement('link');
    heroLink.rel = 'preload';
    heroLink.as = 'image';
    heroLink.href = 'https://cdn.magicpatterns.com/uploads/dHjdkFVq1CSwAqzQEJKpPD/ChatGPT_Image_11_feb_2026,_04_40_03_p.m..webp';
    heroLink.type = 'image/webp';
    document.head.appendChild(heroLink);
    // Preload primary font file (not the CSS)
    const fontLink = document.createElement('link');
    fontLink.rel = 'preload';
    fontLink.as = 'style';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&display=swap';
    document.head.appendChild(fontLink);
    // Defer UTMify pixel until browser is idle
    const loadPixel = () => {
      ;
      (window as any).pixelId = '69828c3d35b55b151494d578';
      const utmScript = document.createElement('script');
      utmScript.setAttribute('async', '');
      utmScript.setAttribute('defer', '');
      utmScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
      document.head.appendChild(utmScript);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel);
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <PricingProvider data-id="element-0">
      <div className="min-h-screen bg-[#0d0d0d] text-white font-sans selection:bg-[#FF6B00] selection:text-white" data-id="element-1">
        <div className="fixed inset-0 z-0 metal-texture opacity-30 pointer-events-none" aria-hidden="true" data-id="element-2" />

        <div className="relative z-10" data-id="element-3">
          <StickyAlertBar data-id="element-4" />

          <main data-id="element-5">
            <HeroSection data-id="element-6" />

            <Suspense fallback={<div className="min-h-[800px] bg-[#111]" style={{
            contain: 'strict'
          }} data-id="element-8" />} data-id="element-7">
              <SalesLetter data-id="element-9" />
            </Suspense>
            <Suspense fallback={<div className="min-h-[600px] bg-[#0d0d0d]" style={{
            contain: 'strict'
          }} data-id="element-11" />} data-id="element-10">
              <FeatureGrid data-id="element-12" />
            </Suspense>
            <Suspense fallback={<div className="min-h-[3000px] bg-[#111]" style={{
            contain: 'strict'
          }} data-id="element-14" />} data-id="element-13">
              <BonusSection data-id="element-15" />
            </Suspense>

            <Suspense fallback={<div className="min-h-[600px] bg-[#111]" style={{
            contain: 'strict'
          }} data-id="element-17" />} data-id="element-16">
              <section className="py-8 px-4 bg-[#111] text-center" data-id="element-18">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-19">
                  RESULTADOS <span className="text-[#FF6B00]" data-id="element-20">REALES</span> DE
                  NUESTROS ALUMNOS
                </h2>
                <WhatsAppCarousel data-id="element-21" />
              </section>
            </Suspense>

            <Suspense fallback={<div className="min-h-[2000px] bg-[#0d0d0d]" style={{
            contain: 'strict'
          }} data-id="element-23" />} data-id="element-22">
              <PricingSection data-id="element-24" />
            </Suspense>
            <Suspense fallback={<div className="min-h-[400px] bg-[#0d0d0d]" style={{
            contain: 'strict'
          }} data-id="element-26" />} data-id="element-25">
              <FAQAccordion data-id="element-27" />
            </Suspense>

            {/* Final CTA */}
            <section className="py-6 px-4 bg-[#111] text-center border-t border-[#333]" data-id="element-28">
              <p className="text-sm text-gray-400 mb-1 uppercase tracking-wider" data-id="element-29">
                PRECIO DE HOY:
              </p>
              <PriceDisplay amount={16.99} className="text-4xl md:text-5xl font-bold text-[#FF6B00] mb-3 block" data-id="element-30" />
              <CTAButton size="xl" className="mb-3" data-id="element-31">
                AGREGAR AL CARRITO
              </CTAButton>
              <p className="text-sm text-gray-400" data-id="element-32">
                Empezá Tu Próximo Proyecto Hoy &gt;&gt;
              </p>
              <p className="text-xs text-gray-500 mt-2" data-id="element-33">
                Pago único. SIN cargos mensuales.
              </p>
            </section>
          </main>

          <footer className="bg-[#0a0a0a] py-6 px-4 border-t border-[#333] text-center" data-id="element-34">
            <div className="max-w-4xl mx-auto" data-id="element-35">
              <div className="text-xs text-gray-600 space-y-2" data-id="element-36">
                <p data-id="element-37">
                  © Sistema Maestro de Herrería — Todos los Derechos Reservados
                </p>
                <div className="flex justify-center gap-4" data-id="element-38">
                  <a href="#" className="hover:text-gray-400" data-id="element-39">
                    Contacto
                  </a>
                  <a href="#" className="hover:text-gray-400" data-id="element-40">
                    Política de Privacidad
                  </a>
                  <a href="#" className="hover:text-gray-400" data-id="element-41">
                    Términos y Condiciones
                  </a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </PricingProvider>;
}